var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 13.3333,
    cy: 22.6666,
    rx: 9.33333,
    ry: 5.33333,
    fill: "#9FA6AB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3333,
    cy: 9.33333,
    rx: 5.33333,
    ry: 5.33333,
    fill: "#9FA6AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 14.2222L23.364 15.8467C23.7819 16.181 24.3888 16.1271 24.7412 15.7243L28 12",
    stroke: "#9FA6AB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCorrect);
export default __webpack_public_path__ + "static/media/user-correct.bd83b84d01ad89437f8496c8545246e9.svg";
export { ForwardRef as ReactComponent };